// edit mode
const DISABLE_EDIT_MODE = false;
const DISABLE_DISCOVER = false;
let editable = DISABLE_EDIT_MODE;
// white list for enable edit mode
// const whiteList = [
//   '15yqiJC3ZT', // easter0823@gmail.com(production)
//   '5d382858c563710014ab0582', // prevengers@funliday.com(production)
//   'rxrVWGOr8s', // vswillie@hotmail.com(production)
//   'xU934NM5NO', // vswillie@hotmail.com
//   '5afa4718d5a86c00149583e2' // easter0823@gmail.com
// ];

export const disableEditMode = memberId =>
  // if (memberId) {
  //   if (whiteList.indexOf(memberId) > -1) {
  //     return false;
  //   }
  // }

  editable;

export const setDisableEditMode = value => {
  editable = value;
};

export const disableDiscover = () => DISABLE_DISCOVER;

export const UTM = {
  MEDIUM: 'social',
  SOURCE: 'funliday'
};

export const isPlannerToolAppType = () => {
  // jslib must be iframe page, so instead of using .env variable, check frameElement
  const appType = !!window.frameElement || window !== window.parent;
  return appType;
};
